module.exports = __webpack_public_path__ + "img/appraisals.30e9e0a.png";